// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3LMnL","sendOtp":"AuthorizeToLogin_sendOtp__abrXP"};